

import barba from '@barba/core';
import anime from 'animejs';


export default class{

	constructor(){
        barba.hooks.afterOnce((data) => {
            // this.trigger = new ScrollTrigger()
            // this.initailTrigger()
            this.init()
        });
        // barba.hooks.leave((data) => {
        //     this.kill(data)
        // });
        barba.hooks.afterEnter((data) => {
            if(data.trigger==='back' || data.trigger==='forward'){
                const sections = document.querySelectorAll('[data-scroll-trigger]')
                if( sections.length > 0 ){
                    sections.forEach( el => { 
                        el.classList.add('visible')
                    })
                }
            }else{
                this.init()
            }
            // this.trigger = new ScrollTrigger()
            // this.initailTrigger()
        });

    }
    init(){
        const callback = (entries) => {
            entries.forEach( (entry) => {
                
                if (entry.isIntersecting) {
                    visible(entry.target);
                }
            });
        }
        const observerOptions = {
            rootMargin: "0px 0px -20% 0px",
            threshold: 0
        }
        this.observer = new IntersectionObserver(callback, observerOptions)
        const sections = document.querySelectorAll('[data-scroll-trigger]')
        if( sections.length > 0 ){
            sections.forEach( el => { 
                this.observer.observe(el)
            })
        }

        const strAnimations = document.querySelectorAll('[data-scroll-trigger="translateY"]')
        if(strAnimations.length > 0 ){
            strAnimations.forEach((el) => {
                let _str = el.textContent.split("");
                let str = "";
                _str.map( s => {
                    str += "<span class='str__animation'>" + s  + "</span>";
                })
                    
                el.innerHTML = str;
            })
        }

        const visible = (t) => {
            const triggerType = t.getAttribute('data-scroll-trigger')
            if(!t.classList.contains('visible')){

                if(triggerType == 'translateY'){
                    const strs = t.querySelectorAll('.str__animation');

                    anime({
                        targets: strs,
                        translateY:['100%',0],
                        easing: 'easeInOutSine',
                        duration: 800,
                        delay: function(el, i) { return i * 20 },
                        complete :()=>{
                            t.classList.add('visible')
                        }
                    });
                }else{
                    t.classList.add('visible')
                }
            }

            
        }
    }
    kill (data){
        // const sections = document.querySelectorAll('[data-scroll-trigger]')
        // console.log(data.trigger)
        // if(data.trigger!=='back' && data.trigger!=='forward'){
        //     if( sections.length > 0 ){
        //         sections.forEach( el => { 
        //             el.classList.add('invisible')  
        //             this.observer.unobserve(el)
        //         })
        //     }
        // }
    }
    // initailTrigger(){
    //     this.trigger.add('[data-scroll-trigger]', {
    //         once: true,
    //         offset: {
               
    //             viewport: {
    //                 x: 0,
    //                 y: (trigger, frame, direction) => {
    //                     return trigger.visible ? 0 : 0.2
    //                 }
    //             }
    //         },
    //         toggle: {
    //             // class: {
    //             //     in: 'visible',
    //             //     out: ['invisible', 'extraClassToToggleWhenHidden']
    //             // },
    //             // callback: {
    //             //     in: null,
    //             //     visible: null,
    //             //     out: (trigger) => {
    //             //         return new Promise((resolve, reject) => {
    //             //             setTimeout(resolve, 10)
    //             //         })
    //             //     }
    //             // }
    //         }
    //     })

    //     const strAnimations = document.querySelectorAll('[data-scroll-trigger="translateY"]')
    //     if(strAnimations.length > 0 ){
    //         strAnimations.forEach((el) => {
    //             let _str = el.textContent.split("");
    //             let str = "";
    //             _str.map( s => {
    //                 str += "<span class='str__animation'>" + s  + "</span>";
    //             })
                    
    //             el.innerHTML = str;
    //         })
    //     }

    //     this.trigger.add('[data-scroll-trigger="translateY"]',
    //         { 
    //             once: true,
    //             offset: {
    //                 viewport: {
    //                     y: (trigger, frame, direction) => {
    //                         return trigger.visible ? 0 : .2
    //                     }
    //                 }
    //             },
    //             toggle: {
    //                 callback: {
    //                     in: (trigger) => {
                            
    //                         const strs = trigger.element.querySelectorAll('span');

    //                         anime({
    //                             targets: strs,
    //                             translateY:['100%',0],
    //                             easing: 'easeOutExpo',
    //                             duration: 800,
    //                             delay: function(el, i) { return i * 20 }
    //                         });
            
    //                     }
    //                 }
    //             }
    //         },
    //     )
    // }
}